import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getDataFromStore } from "../store/getStore";
import { apiLoadingEnd, apiLoading } from '../store/notification/action';

export const getToken = () => {
    let auth = getDataFromStore("Auth");
    return auth?.authDetails?.data.token;
};

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        if (getToken())
            headers.set('token', `${getToken()}`);
        return headers;
    },
    onStart: (request, { dispatch }) => {
        dispatch(apiLoading());
    },
    onError: (error, { dispatch }) => {
        dispatch(apiLoadingEnd());
    },
    transformRequest: (body, headers) => {
        // console.log('transform request');
        const contentType = headers.get('Content-Type');
        if (contentType === 'application/json') {
            return JSON.stringify(body);
        }
        return body;
    },
});

export { baseQuery };
